"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Footer_1 = __importDefault(require("../Footer"));
var styles_1 = require("./styles");
var AuthFrame = function (_a) {
    var children = _a.children, page = _a.page, onLanguageChange = _a.onLanguageChange, selectedLanguage = _a.selectedLanguage, footerMessages = _a.footerMessages, availableLanguages = _a.availableLanguages, logoUrl = _a.logoUrl, backgroundUrl = _a.backgroundUrl, backgroundPosition = _a.backgroundPosition;
    var languageChange;
    if (page !== 'reset-password') {
        languageChange = {
            selectedLanguage: selectedLanguage !== null && selectedLanguage !== void 0 ? selectedLanguage : '',
            onChange: onLanguageChange || (function () { return null; }),
            availableLanguages: availableLanguages,
        };
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ id: "auth-frame-container" }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.Content, __assign({ id: "auth-frame-content" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.Logo, { id: "auth-frame-logo", src: logoUrl, alt: "logo" }), (0, jsx_runtime_1.jsx)(styles_1.Body, __assign({ id: "auth-frame-body" }, { children: children }))] })), (0, jsx_runtime_1.jsx)(styles_1.Background, { id: "auth-frame-bg", style: { backgroundImage: "url(".concat(backgroundUrl, ")"), backgroundPosition: backgroundPosition } })] })), (0, jsx_runtime_1.jsx)(Footer_1.default, { messages: footerMessages, languageChange: languageChange })] }));
};
exports.default = AuthFrame;
